import {AllAccountsDocument} from '@transactions/graphql';
import type {DataProxy} from '@apollo/client';
import type {AllAccountsQuery, AccountFragment} from '@transactions/graphql';

export const addAccount = (store: DataProxy, newAccount?: AccountFragment) => {
  const data = store.readQuery<AllAccountsQuery>({
    query: AllAccountsDocument,
  });
  const existing = data?.allAccounts;
  if (existing && newAccount) {
    store.writeQuery({
      query: AllAccountsDocument,
      data: {
        allAccounts: [...existing, newAccount],
      },
    });
  }
};
